var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.501 1.5V2.33812C16.8994 2.87766 19.501 5.82187 19.501 9.375V10.9406C19.501 13.0687 20.2275 15.1359 21.5541 16.8L22.2525 17.6719C22.5244 18.0094 22.576 18.4734 22.3885 18.8625C22.201 19.2516 21.8072 19.5 21.376 19.5H2.62599C2.19333 19.5 1.79934 19.2516 1.61203 18.8625C1.42467 18.4734 1.47736 18.0094 1.74755 17.6719L2.44645 16.8C3.7763 15.1359 4.50098 13.0687 4.50098 10.9406V9.375C4.50098 5.82187 7.10255 2.87766 10.501 2.33812V1.5C10.501 0.671719 11.1713 0 12.001 0C12.8307 0 13.501 0.671719 13.501 1.5ZM11.626 4.5C8.93536 4.5 6.75098 6.68437 6.75098 9.375V10.9406C6.75098 13.1859 6.10036 15.375 4.89052 17.25H19.1119C17.9025 15.375 17.251 13.1859 17.251 10.9406V9.375C17.251 6.68437 15.0666 4.5 12.376 4.5H11.626ZM15.001 21C15.001 21.7547 14.6869 22.5609 14.1244 23.1234C13.5619 23.6859 12.7557 24 12.001 24C11.2041 24 10.44 23.6859 9.87755 23.1234C9.31505 22.5609 9.00098 21.7547 9.00098 21H15.001Z",
    fill: "#707A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.1ac7f6c9e9b28073dec998ed8b4573bf.svg";
export { ForwardRef as ReactComponent };